import React from 'react';
import ReactDOM from 'react-dom/client';
import LocalRoutes from './routes';
// import history from './browserHistory';
import { Themes } from "itaf";

import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

import { CommonProvider } from 'itaf';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={Themes.default}>
      <CommonProvider>
        <CssBaseline />
        <LocalRoutes />
      </CommonProvider>
    </ThemeProvider>
  </StyledEngineProvider>
);
